import { useChecklistStore } from "@/react/stores/useChecklistStore";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import type { Step } from "../../types";
import { MarkCompleteButton } from "./MarkCompleteButton";
import { StepIcon } from "./StepIcon";
import { StepWrapper } from "./StepWrapper";

interface FocusedStepProps {
  isVisible: boolean;
  step: Step;
}

export const FocusedStep = ({ step, isVisible }: FocusedStepProps) => {
  const { setFocusedStepKey } = useChecklistStore();

  const handleFocus = () => setFocusedStepKey(step.key);

  const handleCtaClick = async () => {
    await step.customAction?.();
  };

  const CustomContent = step.customContent;

  return (
    <StepWrapper isVisible={isVisible}>
      <div className="flex items-start gap-x-4 rounded-xl px-4 py-5">
        <div className="shrink-0 pt-2">
          <StepIcon status={step.complete ? "complete" : "incomplete"} />
        </div>
        <div className="flex-1">
          <button
            type="button"
            className="mb-3 w-full text-left"
            onClick={handleFocus}
          >
            <Typography.LabelSm
              weight="medium"
              size="text-sm"
              color="text-dark"
              textTransform={step.complete ? "line-through" : "none"}
            >
              {step.title}
            </Typography.LabelSm>
            <Typography.BodySm
              weight="medium"
              size="text-sm"
              color="text-default"
            >
              {step.description}
            </Typography.BodySm>
          </button>
          {CustomContent && <CustomContent />}
          <div className="flex items-center gap-x-3">
            <Button variant="circle" small onClick={handleCtaClick}>
              {step.cta}
            </Button>
            {!step.complete && <MarkCompleteButton stepKey={step.key} />}
          </div>
        </div>
      </div>
    </StepWrapper>
  );
};
